import * as types from "../../types";

export default function (state = [], action) {
    const { type, payload } = action;

    switch (type) {
        case types.GET_USER_EQUITY:
            return {
                ...state,
                equity: payload
            };
        default:
            return state;
    }
}